
import { of as observableOf,  Observable } from 'rxjs';
import { Injectable,OnInit } from '@angular/core';


let counter = 0;

@Injectable()
export class UserService implements OnInit {

  currentUser= JSON.parse(localStorage.getItem('currentUser'));
  mPhoto= localStorage.getItem('mPhoto');

    

  private users = {
    nick: { name: this.currentUser.fname, picture: this.mPhoto },
    eva: { name: 'Eva Moor', picture: 'assets/images/eva.png' },
    jack: { name: 'Jack Williams', picture: 'assets/images/jack.png' },
    lee: { name: 'Lee Wong', picture: 'assets/images/lee.png' },
    alan: { name: 'Alan Thompson', picture: 'assets/images/alan.png' },
    kate: { name: 'Kate Martinez', picture: 'assets/images/kate.png' },
  };

  private userArray: any[];

  constructor() {
    // this.userArray = Object.values(this.users);
  }
  ngOnInit()
  {
    this.mPhoto= localStorage.getItem('mPhoto');
    if(this.currentUser.photo!==null)
    {
      this.users.nick.picture=this.currentUser.photo;
    }
    else{
      this.users.nick.picture=this.mPhoto;
    }

  }

  getUsers(): Observable<any> {
    return observableOf(this.users);
  }

  getUserArray(): Observable<any[]> {
    return observableOf(this.userArray);
  }

  getUser(): Observable<any> {
    counter = (counter + 1) % this.userArray.length;
    return observableOf(this.userArray[counter]);
  }
}
